import {
  NormalRetireFlowReason,
  RetireReason,
} from "../../assets/data/Constants";
import { labelids } from "../../assets/data/TkExplanationProperty";
import { ITkFakeTableLineProps } from "../../type/componentsType/TkFakeTableLine";
import { IJob_32Props } from "../../type/contextType/businessContext/IJob_32";
import { TkGetCodeList } from "../../utils/TkGetCode";
import TkPropertyMessageGet from "../../utils/TkPropertyMessageGet";

const stepper = [
  "退職者の基本情報登録",
  "添付書類の登録",
  "従業状況の登録確認",
  "退職者した月以前６ヶ月の本俸月額登録",
  "退職手当金請求の順番登録",
  "源泉徴収票の登録",
  "登録内容の確認",
  "機構へ提出",
];

const fakeTableList: ITkFakeTableLineProps[] = [
  {
    keyword: "infoManual",
    type: "explanatoryText",
    explanatoryText: labelids.labelid.LBLC060120_01,
  },
  {
    keyword: "contractorName",
    type: "contractorAndNumber",
    contractorName: "契約者（法人）名",
    showLine: false,
  },
  {
    title: "職員番号",
    keyword: "staffNo",
    type: "text",
    helpicon: true,
    helpText: "被共済職員の番号です。",
  },
  {
    title: "退職者名",
    keyword: "staffNameKanji",
    type: "name",
    firstNameLabel: true,
    requiredIcon: true,
    helpicon: true,
    helpText:
      "退職する職員の氏名です。結婚等で苗字が変更されている場合は更新してください。なお、外国人については、フリガナ、漢字欄ともに「カタカナ」で入力をしてください。",
  },
  {
    title: "退職者カナ",
    keyword: "staffNameKana",
    type: "name",
    useFurigana: true,
    hafWidth: true,
    convertToHalfwidth: true,
    requiredIcon: true,
  },
  {
    title: "退職者生年月日",
    keyword: "birthday",
    type: "date",
    minDate: new Date("1900/01/01"),
    maxDate: new Date(),
    requiredIcon: true,
    helpicon: true,
    helpText: "退職者の生年月日です。誤りがある場合は修正してください。",
  },
  {
    title: "退職者加入年月日",
    keyword: "firstJoinDate",
    type: "text",
    helpicon: true,
    helpText:
      "退職者が当制度に加入された年月日です。被共済職員期間が合算等されている場合は当初の加入年月日を表示しています。",
  },
  {
    title: "退職年月日",
    keyword: "retireDate",
    type: "date",
    minDate: new Date("1900/01/01"),
    maxDate: new Date("2099/12/31"),
    requiredIcon: true,
    helpicon: true,
    helpText:
      "退職年月日を登録してください。直接入力していただくか、「カレンダーボタン」にて日付を選択してください。",
  },
  {
    title: "退職理由",
    keyword: "retireReasonCd",
    type: "selectForm",
    selectPropsList: TkGetCodeList(RetireReason),
    guideMessage: (
      <>
        現在、ご選択中の退職理由は、労働災害又は通勤災害による傷病や死亡による退職を理由とするものであり、証明する書類が必要となります。
        <br />
        傷病による場合は、障害の程度が厚生年金保険法第４７条第２項に規定する障害等級に該当することが必要です。
        <br />
        また、死亡による場合は、労災保険の適用を受けていることが必要です。
        <br />
        労働災害又は通勤災害と関連がない場合は普通退職となりますので、関連がない場合は普通退職を選択してください。
      </>
    ),
    requiredIcon: true,
    helpicon: true,
    helpText: (
      <>
        「普通退職」「業務上の傷病又は死亡による退職」「犯罪等による退職」のいずれかから選択してください。
        <br />
        なお、選択にあたっての留意点は次のとおりです。
        <br />
        ・「普通退職」：一身上の都合による退職、定年退職、雇用期間満了による退職などが該当します。以下の「業務上の傷病又は死亡による退職」、「犯罪等による退職」に該当しない場合は、「普通退職」を選択してください。
        <br />
        ・「業務上の傷病又は死亡による退職」：業務災害（通勤災害）に起因する傷病・死亡による退職が該当します。なお、業務災害（通勤災害）に起因する傷病・死亡による退職であることを証する添付書類の提出が必要となります。添付書類を機構にて確認した結果、退職理由を「普通退職」とする場合があります。
        <br />
        ・「犯罪等による退職」：犯罪行為、またはこれに準ずべき重大な非行行為による退職が該当します。なお、犯罪行為、またはこれに準ずべき重大な非行行為による退職であることを証する添付書類の提出が必要となります。添付書類を機構にて確認した結果、退職理由を「普通退職」とする場合があります（単なる就業規則違反に該当するもの、罰金刑が確定しているものは退職理由「①普通退職」として届け出てください。）。「犯罪等による退職」であると機構が認定した場合は退職手当金が不支給となるため、審査に相応の時間を必要とします。
      </>
    ),
  },
  {
    title: "退職手続きの理由",
    keyword: "retireProcedureReason",
    type: "radio",
    radioPropsList: TkGetCodeList(NormalRetireFlowReason),
    requiredIcon: true,
    helpicon: true,
    helpText:
      "退職理由に応じて選択してください。なお、「普通退職」における「死亡による退職」とは、業務災害（通勤災害）に起因する死亡以外によって退職する場合が該当します。また、「普通退職」における「法人（業務上の）都合」とは、共済契約者間で施設運営上の理由により人材を融通することを事前に合意した転職のみが対象となります。それ以外のケースについては、自己都合を選択してください。",
  },
  {
    title: "退職者郵便番号",
    keyword: "zipcode",
    requiredIcon: true,
    type: "addressSearch",
    inputProps: { maxLength: 7 },
    helpicon: true,
    helpText: "退職者の居住場所の郵便番号を入力してください。",
  },
  {
    title: "退職者住所",
    keyword: "address",
    type: "locationGroup",
    requiredIcon: true,
    inputProps: { maxLength: 85 },
    helpicon: true,
    helpText: "退職者の居住場所の住所を入力してください。",
  },
  {
    title: "退職者電話番号",
    keyword: "tel",
    type: "phoneNum",
    requiredIcon: true,
    helpicon: true,
    helpText: "退職者に連絡が取れる電話番号（携帯電話可）を入力してください。",
  },
];

const schema = {
  staffNameKanji: {
    validate: (data: any) => {
      let error = "";

      if (!data.match(/^.+　.*/)) {
        error = TkPropertyMessageGet("TKMSG_SCR0043E");
      } else if (data.length > 48) {
        error = TkPropertyMessageGet("TKMSG_SCR0046E", "47");
      } else if (!data.match(/^[^ -~｡-ﾟａ-ｚＡ-Ｚ]+$/)) {
        error = TkPropertyMessageGet("TKMSG_SCR0073E");
      }

      if (error) {
        const stringified = JSON.stringify(error);
        return stringified.slice(1, stringified.length - 1);
      }
    },
  },
  staffNameKana: {
    validate: (data: any) => {
      const nameParts = data?.split?.(" ") || [];
      const lastName = nameParts[0] ?? ""; //苗字
      const firstName = nameParts[1] ?? ""; //名前

      let error = "";

      if (lastName === "") {
        // lastname未入力の場合＝＞TKMSG_SCR0043E
        error = TkPropertyMessageGet("TKMSG_SCR0043E");
      } else if (lastName.length + firstName.length > 47) {
        // 47文字以上の場合＝＞TKMSG_SCR0046E
        error = TkPropertyMessageGet("TKMSG_SCR0046E", "47");
      } else if (
        !lastName.match(/^[ｧ-ﾝｦﾞﾟ\s-]*$/) ||
        !firstName?.match(/^[ｧ-ﾝｦﾞﾟ\s-]*$/)
      ) {
        // lastNameもしくはfirstNameが半角ｶﾅでなかった場合　＝＞TKMSG_SCR0054E
        error = TkPropertyMessageGet("TKMSG_SCR0054E");
      } else {
        error = "";
      }

      if (error !== "") {
        const stringified = JSON.stringify(error);
        return stringified.slice(1, stringified.length - 1);
      }
    },
  },
  birthday: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
  },
  retireDate: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
  },
  retireReasonCd: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
  zipcode: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    minLength: {
      value: 7,
      message: TkPropertyMessageGet("TKMSG_SCR0077E", "7"),
    },
  },
  address: {
    validate: (data: any) => {
      let error = {
        prefectures: "",
        city: "",
        address: "",
      };

      error = {
        prefectures: !data?.prefectures
          ? TkPropertyMessageGet("TKMSG_SCR0043E")
          : "",
        city: !data?.city
          ? TkPropertyMessageGet("TKMSG_SCR0043E")
          : data.city.length > 20
          ? TkPropertyMessageGet("TKMSG_SCR0046E", "20")
          : !data.city.match(/^[^ -~｡-ﾟ]+$/)
          ? TkPropertyMessageGet("TKMSG_SCR0061E")
          : "",
        address: !data?.address
          ? TkPropertyMessageGet("TKMSG_SCR0043E")
          : data.address.length > 85
          ? TkPropertyMessageGet("TKMSG_SCR0046E", "85")
          : !data.address.match(/^[^ -~｡-ﾟ]+$/)
          ? TkPropertyMessageGet("TKMSG_SCR0061E")
          : "",
      };

      if (
        error.prefectures !== "" ||
        error.city !== "" ||
        error.address !== ""
      ) {
        return JSON.stringify(error);
      }
    },
  },
  tel: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 19,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "19"),
    },
  },
};

const retireSchema = {
  retireProcedureReason: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
};

const contextEditInfoList = {
  "JOB-33": [
    "prefectureRetirementJoinFlg",
    "retirementRequestOrder",
    "withholdingTaxSlipTotal",
    "page1Kbn",
    "page1PaymentAmt",
    "page1WithholdingAmt",
    "page1ScAmtCity",
    "page1ScAmtPrefecture",
    "page1LengthOfService",
    "page1EmployedDate",
    "page1RetiredDate",
    "page1DeductionPeriodYear",
    "page1DeductionPeriodMonth",
    "page2Kbn",
    "page2PaymentAmt",
    "page2WithholdingAmt",
    "page2ScAmtCity",
    "page2ScAmtPrefecture",
    "page2LengthOfService",
    "page2EmployedDate",
    "page2RetiredDate",
    "page2DeductionPeriodYear",
    "page2DeductionPeriodMonth",
    "page3Kbn",
    "page3PaymentAmt",
    "page3WithholdingAmt",
    "page3ScAmtCity",
    "page3ScAmtPrefecture",
    "page3LengthOfService",
    "page3EmployedDate",
    "page3RetiredDate",
    "page3DeductionPeriodYear",
    "page3DeductionPeriodMonth",
  ],
  "JOB-32": [
    "continueTransferApplicable1Flg",
    "continueTransferApplicable2Flg",
    "aContractorNo",
    "aCorpName",
  ],
  "JOB-31": [
    "continueTransferApplicable1Flg",
    "continueTransferApplicable2Flg",
    "aContractorNo",
    "aCorpName",
  ],
} as { [key: string]: (keyof IJob_32Props)[] };

export { stepper, fakeTableList, schema, retireSchema, contextEditInfoList };
